import {withComponent} from '../../hoc/withComponent';
import {DialogActionsBase} from './DialogActionsBase';

export const withDialogActions = withComponent(DialogActionsBase);
